/**
 * Created by hp on 2017/8/22.
 */
import React, {Component} from 'react';
import {
    CellsTitle,
    MediaBox,
    MediaBoxHeader,
    MediaBoxBody,
    MediaBoxTitle,
    MediaBoxDescriptio,
    PanelBody
} from 'react-weui';


class ComplainAccount extends Component {
    render() {
        const {data, liveroom, createAccount} = this.props;
        return (
            <div className="complain-account">
                <CellsTitle>投诉账号</CellsTitle>

                <PanelBody>
                    <MediaBox type="appmsg" href="javascript:void(0);">
                        <MediaBoxHeader>
                            <img src={liveroom.small_avatar_url} />
                        </MediaBoxHeader>
                        <MediaBoxBody>
                            <MediaBoxTitle>{data.name}</MediaBoxTitle>
                            <MediaBoxTitle>创建者：{createAccount.nickname}</MediaBoxTitle>
                        </MediaBoxBody>
                    </MediaBox>
                </PanelBody>
            </div>
        )
    }
}

export default ComplainAccount;



// WEBPACK FOOTER //
// ./src/components/complain/ComplainAccount.js